<div class="h-full flex flex-col justify-start items-center overflow-hidden space-y-4">
    <div
        class="flex-0 flex flex-row items-center justify-between w-full border-b border-zinc-200 dark:border-zinc-800 pb-2">
        <div>
            <button (click)="goBack()" type="button" class="fab-button-secondary">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5">
                    <path d="m12 19-7-7 7-7" />
                    <path d="M19 12H5" />
                </svg>
            </button>
        </div>


        <div class="">
            <div class="grid grid-cols-1 sm:hidden">
                <select aria-label="Select a tab" (change)="selectTabMobile($event)"
                    class="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white/5 py-2 pl-3 pr-8 text-base text-gray-100 outline outline-1 -outline-offset-1 outline-white/10 *:bg-gray-800 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary">
                    <option [selected]="selectedTab() === 'find'" value="find">Find Products</option>
                    <option [selected]="selectedTab() === 'list'" value="list">List Products</option>
                    
                </select>
                <svg viewBox="0 0 16 16" fill="currentColor" data-slot="icon" aria-hidden="true"
                    class="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end fill-gray-400">
                    <path
                        d="M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z"
                        clip-rule="evenodd" fill-rule="evenodd" />
                </svg>
            </div>
            <div class="hidden sm:block">
                <nav aria-label="Tabs" class="flex space-x-4">
                    <a (click)="selectTab('find')"
                        class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                        [class]="getTabClass('find')">Find Products</a>
                    <a (click)="selectTab('list')" class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                        [class]="getTabClass('list')">List Products</a>
                </nav>
            </div>
        </div>



    </div>

    <div class="flex-1 flex-col items-center justify-center w-full overflow-hidden">

    </div>
</div>